var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.297,
    height: 17.479,
    viewBox: "0 0 26.297 17.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(0 -8.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M6.549,15.416c3.477-2.341,4.6-3.994,4.6-4.428H13.5V28.467h-2.35c0-.434-1.125-2.087-4.6-4.428C3.633,22.076.929,20.9,0,20.9v-2.35c.929,0,3.633-1.174,6.549-3.137",
    transform: "translate(0 -2.401)",
    fill: "#001233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M22.923,15.416c3.477-2.341,4.6-3.994,4.6-4.428h2.35V28.467h-2.35c0-.434-1.125-2.087-4.6-4.428C20.007,22.076,17.3,20.9,16.374,20.9v-2.35c.929,0,3.633-1.174,6.549-3.137",
    transform: "translate(-3.578 -2.401)",
    fill: "#001233"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewind);
export default __webpack_public_path__ + "static/media/rewind.1906bda433883349ae0a0daeb75d4151.svg";
export { ForwardRef as ReactComponent };